import React from 'react';
import { Dot, LoadingDots } from './DotLoader.styled';

const DotLoader = () => (
    <LoadingDots>
        <Dot />
        <Dot />
        <Dot />
    </LoadingDots>
);

export default DotLoader;
